import { useEffect } from 'react';

import { useTotalNumberOfUnreadEvents } from '$app-web/components/chat/state/chat-client.state';

type ReportCount = (count: number) => void;

export function useUnreadCountReporter(reportCount: ReportCount) {
    const numberOfEventsByRoom = (useTotalNumberOfUnreadEvents() ?? {}) as Record<string, number>;
    const totalCount = Object.values(numberOfEventsByRoom).reduce((acc, val) => acc + val, 0);

    useEffect(() => {
        reportCount(totalCount);
    }, [totalCount, reportCount]);
}
